import theme from '@styles/theme';

export default {
  priceContainer: {
    textAlign: 'end',
    minHeight: '22px',
  },
  discountedPrice: {
    color: theme.rawColors.accent700,
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.bigText,
    textTransform: 'lowercase',
    whiteSpace: 'nowrap',
  },
  basePrice: (discount: boolean) => ({
    color: discount ? theme.rawColors.darkGrey300 : theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.bigText,
    position: 'relative',
    textTransform: 'lowercase',
    display: 'inline-block',
    whiteSpace: 'nowrap',

    '&:after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      borderTop: discount ? `1px solid ${theme.rawColors.darkGrey300}` : 'none',
    },
  }),
};
